import { render, staticRenderFns } from "./ReportBenchmarksForm.vue?vue&type=template&id=f19aa368&scoped=true"
import script from "./ReportBenchmarksForm.vue?vue&type=script&lang=ts"
export * from "./ReportBenchmarksForm.vue?vue&type=script&lang=ts"
import style0 from "./ReportBenchmarksForm.vue?vue&type=style&index=0&id=f19aa368&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19aa368",
  null
  
)

export default component.exports